var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import axios from 'axios';
import { JourneyCompleted } from '@account-verification-frontend/journey-completed';
import { Summary } from '@account-verification-frontend/summary';
import { IframeContainer } from '@account-verification-frontend/iframe-container';
import { DocumentTypes } from '@account-verification-frontend/document-types';
import { CLASSNAME_PREFIX } from './componentConfig';
import { createUrl, getQueryParameter } from './utils';
import { DocumentStatus } from '@account-verification-frontend/types';
import { Spinner } from '@sitebase/ui-kit';
import { AxiosRequestMethod, AV_FRONTEND_INIT_CAPTURE_ENDPOINT, AV_FRONTEND_SUMMARY_ENDPOINT, AV_FRONTEND_UPLOAD_CONFIRMATION_ENDPOINT, TOKEN_SOURCE_QUERY_PARAMETER, FLOW_QUERY_PARAMETER, HTTP_STATUS_CODE_VERIFICATION_ERROR, } from './constants';
import { ErrorPage } from './errorPage';
import { VerificationErrorPage } from './verificationErorrPage';
import './Scenarios.scss';
var wrapperClassName = CLASSNAME_PREFIX + "-component";
var Scenarios = (function (_super) {
    __extends(Scenarios, _super);
    function Scenarios() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            summaryData: [],
            isLoading: false,
            serverError: null,
            redirectUrl: '',
            currentStep: null,
            scenarioType: '',
            firstName: '',
        };
        _this.setCurrentStep = function (scenarios, firstName) {
            var isVerificationDone = !scenarios.length || Scenarios.isVerified(scenarios);
            if (Scenarios.isVerificationError(scenarios)) {
                _this.setState({ firstName: firstName, currentStep: "5" });
                return;
            }
            if (isVerificationDone) {
                _this.setState({ currentStep: "4" });
            }
            else {
                if (Scenarios.isSubmitted(scenarios)) {
                    _this.setState({ currentStep: "3" });
                }
                else {
                    _this.setState({ summaryData: scenarios, currentStep: "0" });
                }
            }
        };
        _this.setViewportHeightProperty = function () {
            var vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', vh + "px");
        };
        _this.goBack = function () {
            _this.setState({ currentStep: "0" });
        };
        _this.receivePostMessage = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var tokenSource, _a, transactionReference, value;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(event.data && Object.keys(event.data).length)) return [3, 3];
                        tokenSource = getQueryParameter(TOKEN_SOURCE_QUERY_PARAMETER);
                        _a = JSON.parse(event.data), transactionReference = _a.transactionReference, value = _a.payload.value;
                        if (!value) return [3, 3];
                        if (!(value.toLowerCase() === "success")) return [3, 2];
                        return [4, this.createAsyncRequest(AxiosRequestMethod.POST, AV_FRONTEND_UPLOAD_CONFIRMATION_ENDPOINT, {
                                tokenSource: tokenSource,
                                transactionReference: transactionReference,
                            })];
                    case 1:
                        _b.sent();
                        this.resetState();
                        _b.label = 2;
                    case 2:
                        if (value.toLowerCase() === "error") {
                            this.resetState();
                        }
                        _b.label = 3;
                    case 3: return [2];
                }
            });
        }); };
        _this.onDocumentChosen = function (documentType) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.initCaptureRequest({ scenarioType: this.state.scenarioType, documentType: documentType })];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); };
        _this.initCaptureRequest = function (postData) { return __awaiter(_this, void 0, void 0, function () {
            var tokenSource, data, redirectUrl, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        tokenSource = getQueryParameter(TOKEN_SOURCE_QUERY_PARAMETER);
                        if (tokenSource) {
                            postData = __assign({}, postData, { tokenSource: tokenSource });
                        }
                        return [4, this.createAsyncRequest(AxiosRequestMethod.POST, AV_FRONTEND_INIT_CAPTURE_ENDPOINT, postData)];
                    case 1:
                        data = _a.sent();
                        redirectUrl = data.redirectUrl;
                        this.setState({ redirectUrl: redirectUrl, currentStep: "2" });
                        window.addEventListener('message', this.receivePostMessage, false);
                        return [3, 3];
                    case 2:
                        e_1 = _a.sent();
                        this.setState({ serverError: HTTP_STATUS_CODE_VERIFICATION_ERROR, isLoading: false });
                        return [3, 3];
                    case 3: return [2];
                }
            });
        }); };
        _this.onScenarioChosen = function (verificationType, scenarioType) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(verificationType === "DOCUMENT")) return [3, 1];
                        this.setState({ currentStep: "1", scenarioType: scenarioType });
                        return [3, 3];
                    case 1: return [4, this.initCaptureRequest({ scenarioType: scenarioType })];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2];
                }
            });
        }); };
        return _this;
    }
    Scenarios.isVerified = function (data) {
        return data.every(function (scenarioObj) {
            return scenarioObj.status === DocumentStatus.VERIFIED;
        });
    };
    Scenarios.isSubmitted = function (data) {
        return data.every(function (scenarioObj) {
            var status = scenarioObj.status;
            return status === DocumentStatus.SUBMITTED || status === DocumentStatus.VERIFIED;
        });
    };
    Scenarios.isVerificationError = function (data) {
        var areAllDocsUploaded = data.every(function (scenarioObj) {
            return scenarioObj.status !== DocumentStatus.REQUIRED;
        });
        var isDocRejected = data.some(function (scenarioObj) {
            return scenarioObj.status === DocumentStatus.REJECTED;
        });
        return areAllDocsUploaded && isDocRejected;
    };
    Scenarios.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getSummaryData()];
                    case 1:
                        _a.sent();
                        this.setViewportHeightProperty();
                        window.addEventListener('resize', this.setViewportHeightProperty);
                        return [2];
                }
            });
        });
    };
    Scenarios.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.setViewportHeightProperty);
    };
    Scenarios.prototype.render = function () {
        var _a = this.state, isLoading = _a.isLoading, serverError = _a.serverError, summaryData = _a.summaryData, currentStep = _a.currentStep, scenarioType = _a.scenarioType;
        if (serverError) {
            return (React.createElement("div", { className: wrapperClassName },
                React.createElement(ErrorPage, { error: serverError })));
        }
        return (React.createElement("div", { className: wrapperClassName },
            currentStep && this.renderView(currentStep, summaryData, scenarioType),
            isLoading && (React.createElement("span", { className: CLASSNAME_PREFIX + "-spinner" },
                React.createElement(Spinner, null)))));
    };
    Scenarios.prototype.getSummaryData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tokenSource, flow, data, scenarios, firstName;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tokenSource = getQueryParameter(TOKEN_SOURCE_QUERY_PARAMETER);
                        flow = getQueryParameter(FLOW_QUERY_PARAMETER);
                        return [4, this.createAsyncRequest(AxiosRequestMethod.POST, AV_FRONTEND_SUMMARY_ENDPOINT, {
                                tokenSource: tokenSource,
                                flow: flow,
                            })];
                    case 1:
                        data = _a.sent();
                        if (data && Array.isArray(data.scenarios)) {
                            scenarios = data.scenarios, firstName = data.firstName;
                            this.setCurrentStep(scenarios, firstName);
                        }
                        return [2];
                }
            });
        });
    };
    Scenarios.prototype.renderView = function (currentStep, data, scenarioType) {
        var _a;
        var scenarioData = data && data.filter(function (scenario) { return scenario.scenarioType === scenarioType; }).shift();
        var documents = scenarioData && scenarioData.payload ? scenarioData.payload.supportedDocuments : [];
        var steps = (_a = {},
            _a["0"] = React.createElement(Summary, { data: data, clickHandler: this.onScenarioChosen }),
            _a["1"] = (React.createElement(DocumentTypes, { stepBack: this.goBack, documents: documents, onDocumentChosen: this.onDocumentChosen })),
            _a["2"] = React.createElement(IframeContainer, { iframeLink: this.state.redirectUrl }),
            _a["3"] = React.createElement(JourneyCompleted, null),
            _a["4"] = React.createElement(JourneyCompleted, { verified: true }),
            _a["5"] = React.createElement(VerificationErrorPage, { firstName: this.state.firstName }),
            _a);
        if (currentStep && steps[currentStep]) {
            return steps[currentStep];
        }
    };
    Scenarios.prototype.createAsyncRequest = function (method, endpoint, postData) {
        return __awaiter(this, void 0, void 0, function () {
            var serviceRequest, data, e_2, responseCode;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        serviceRequest = createUrl(endpoint);
                        this.setState({ isLoading: true });
                        return [4, axios({
                                method: method,
                                url: serviceRequest,
                                data: JSON.stringify(postData),
                                headers: { 'Content-Type': 'application/json' },
                            })];
                    case 1:
                        data = (_a.sent()).data;
                        this.setState({ serverError: null, isLoading: false });
                        return [2, data];
                    case 2:
                        e_2 = _a.sent();
                        responseCode = e_2.response && e_2.response.status ? e_2.response.status : HTTP_STATUS_CODE_VERIFICATION_ERROR;
                        this.setState({ serverError: responseCode, isLoading: false });
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Scenarios.prototype.resetState = function () {
        window.removeEventListener('message', this.receivePostMessage);
        this.getSummaryData();
    };
    return Scenarios;
}(React.Component));
export default Scenarios;
//# sourceMappingURL=Scenarios.js.map